<!-- lib/components/Container.svelte -->
<script>
  export let variant = "dark"; // dark, light, transparent
  export let size = "normal"; // compact, normal, large
  export let maxWidth = "var(--max-width)";
  export let padding = null;
  export let id = null;

  let className = "";
  export { className as class };

  $: classes = `container container--${variant} container--${size} ${className}`;
  $: containerStyle = `max-width: ${maxWidth}; ${padding ? `padding: ${padding};` : ""}`;
</script>

<div class={classes} style={containerStyle} {id}>
  <slot />
</div>

<style lang="scss">
  .container {
    margin: 2rem auto;
    box-sizing: border-box;
    position: relative;
  }

  /* Variants */
  .container--dark {
    background-color: var(--card-bg);
    color: var(--text-color1);
    border: 1px solid #260d28;
    border-radius: 1.25rem;
    box-shadow:
      0 1px 2px rgba(255, 255, 255, 0.03) inset,
      0 -1px 2px rgba(0, 0, 0, 0.2) inset,
      0 8px 20px rgba(0, 0, 0, 0.3);
  }

  .container--light {
    background: linear-gradient(135deg, #f8f6f0 0%, #faf8f2 50%, #f6f3eb 100%);
    border: 1px solid #e8e2d4;
    border-radius: 1.25rem;
    box-shadow:
      0 1px 3px rgba(210, 165, 82, 0.1),
      0 8px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin: 2rem auto 2rem auto; /* Consistent spacing above and below */

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(210, 165, 82, 0.3) 50%,
        transparent 100%
      );
    }
  }

  .container--transparent {
    background: transparent;
    border: none;
    box-shadow: none;
  }

  /* Sizes */
  .container--compact {
    padding: 2rem;
  }

  .container--normal {
    padding: 4rem;
  }

  .container--large {
    padding: 6rem;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .container {
      margin: 2rem 1rem;
    }

    .container--light {
      margin: 2rem 1rem 2rem 1rem;
    }

    .container--normal {
      padding: 2rem;
    }

    .container--compact {
      padding: 1.5rem;
    }

    .container--large {
      padding: 3rem;
    }
  }

  @media (max-width: 480px) {
    .container {
      margin: 1rem 0.5rem 0 0.5rem;
    }

    .container--light {
      margin: 1rem 0.5rem 1rem 0.5rem;
    }

    .container--normal {
      padding: 1.5rem;
    }

    .container--compact {
      padding: 1rem;
    }

    .container--large {
      padding: 2rem;
    }
  }

  @media (max-width: 400px) {
    .container {
      margin: 0.5rem 0.25rem 0 0.25rem;
      box-sizing: border-box;
    }

    .container--light {
      margin: 0.5rem 0.25rem 0 0.25rem;
    }

    .container--normal {
      padding: 1rem 0.5rem 0 0.5rem;
    }

    .container--compact {
      padding: 0.75rem 0.5rem 0 0.5rem;
    }

    .container--large {
      padding: 1.25rem 0.75rem 0 0.75rem;
    }

    .document-container {
      padding: 0.5rem 0.25rem;
      margin: 0 !important;
    }
  }

  .document-container {
    @media (max-width: 1024px) {
      padding: 2rem 1rem;
    }

    @media (max-width: 768px) {
      padding: 1rem 1rem;
      margin: 0 !important;
    }

    @media (max-width: 480px) {
      padding: 0.5rem 0.5rem;
      margin: 0 !important;
    }
  }
</style>
